import { EsgIndicator } from "src/app/core/v2/state/esg-indicator/type"
import { ConstructionCategory } from "../../_sub/construction-category"
import { ExternalAspect, newExternalAspect } from "../../_sub/external-aspects"
import { Grounds, newGrounds } from "../../_sub/grounds"
import { InternalAspect, newInternalAspect } from "../../_sub/internal-aspects"
import { newServiceAndInfra, ServiceAndInfra } from "../../_sub/service-and-infra"
import { UpgradesCondition } from "../../_sub/upgrades-condition"
import { LocationData, newLocationData } from "../../_sub/location"
import { AssetClassLandAreaComponentModel, AssetClassLandAreaModel } from "src/app/core/asset_class"
import { RoomSchedule, RoomScheduleType } from "../types"
import { FloorAreaMeasurement } from "../../_sub/floor-area-measurement"
import { AssetClassSizeModel, AssetClassTenure } from "src/app/core/comparable"
import { LocationInfo, newLocationInfo } from "../../../location"

export class HotelComparableAssetClass {
    id: number | undefined = undefined
    ref_num: string | null = null

    status: number = 0
    form_type: number = 2

    location_data: LocationInfo = newLocationInfo()
    add_info_on_land: boolean = false;
    land_parcel_name: string | null = null;
    coordinate_reference_system_id: number | null = null;
    points: any[] = [];
    landArea: AssetClassLandAreaModel;
    boundary_type_id: number | null = null;
    landAreaComponents: AssetClassLandAreaComponentModel[] = [];

    property_type_id: number | null = null
    hotel_rating_id: number | null = null
    hotel_apartment_rating_id: number | null = null
    completion_status: string | null = null
    completion_date: Date | null = null
    estimated_age: number | null = null
    estimated_remaining_lifespan_from: number | null = null
    estimated_remaining_lifespan_to: number | null = null
    developer: string | null = null
    number_of_stories: string | null = null
    views: string | null = null
    plot_id: string | null = null
    plot_area: number | null = null
    makani_no: string | null = null
    dewa_no: string | null = null
    municipality_no: string | null = null
    state_of_repair_desc: string | null = null
    construction_desc: string | null = null
    construction_categories: ConstructionCategory[] = []
    upgrades_condition_id: number | null = null
    upgrades_conditions: UpgradesCondition[] = []
    room_schedule_type: RoomScheduleType | null = null
    number_of_units: string | null = null
    room_schedules: RoomSchedule[] = []
    floor_area_measurement_comment: string | null = null
    floor_area_measurements: FloorAreaMeasurement[] = []
    hotel_accommodation_file: {
        name: string | null
        path: string | null
    } | null = null
    room_schedule_file: {
        name: string | null
        path: string | null
    } | null = null
    outlet_file: {
        name: string | null
        path: string | null
    } | null = null

    service_and_infra: ServiceAndInfra = newServiceAndInfra()
    external_aspect: ExternalAspect = newExternalAspect()
    internal_aspect: InternalAspect = newInternalAspect()
    grounds: Grounds = newGrounds()

    esg_indicator: EsgIndicator | null = null

    sizes: AssetClassSizeModel[] = []
    tenures: AssetClassTenure[] = []

    ac_pictures: any[] = []
    picture: string = '';
    documents: any[] = []

    valuation_id: number | null = null

    size?: string
    can_be_deleted?: boolean
    userDeletedBy?: string
    deletedBy?: string
    createdBy?: string
    lastUpdatedBy?: string
    created_at?: string
    updated_at?: string
    used_times?: number

    constructor() {
        this.landArea = new AssetClassLandAreaModel();
        this.landArea.clear()
    }
}